import { DisplayMode } from '@myre/ui-primitive-core';

export const displayModeDefaultOpenRecord: Record<DisplayMode, boolean> = {
  [DisplayMode.Large]: true,
  [DisplayMode.Medium]: false,
  [DisplayMode.Small]: false,
};

export const rootNodeName = 'root';
